function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFAF20",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.523 2.868c-14.637 0-26.5 12.31-26.5 27.5s11.863 27.5 26.5 27.5c14.635 0 26.5-12.311 26.5-27.5s-11.865-27.5-26.5-27.5zm0 2.292c13.416 0 24.291 11.285 24.291 25.208 0 13.923-10.875 25.208-24.291 25.208-13.418 0-24.292-11.284-24.292-25.208 0-13.924 10.874-25.208 24.292-25.208z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.014 11.46l.413 2.252C26.18 17.515 14.815 31.07 9.255 47.925l-.277.86-2.099-.714c5.586-17.669 17.236-32.078 37.133-36.402l1.002-.208z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.786 11.713c16.903 6.333 30.115 18.8 33.719 39.408l.172 1.038-2.18.368C36.366 32.601 23.972 20.47 7.872 14.19l-.836-.32.75-2.156z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.29 4.1c.578 12.864-9.98 22.965-22.054 21.558l-.576-.076.308-2.27c10.764 1.577 20.315-7.176 20.133-18.527l-.018-.58L24.29 4.1zM25.061 57.237c-10.94-18.387 9.484-39.492 27.05-28.577l.532.34-1.186 1.933c-15.55-10.273-33.96 8.225-24.803 24.604l.286.496-1.879 1.204z"
}));

var SvgRecreationTransactionsIcon = function SvgRecreationTransactionsIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 58,
    style: {
      background: "transparent"
    },
    viewBox: "0 0 53 58",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRecreationTransactionsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/recreation_transactions_icon.f9019fea.svg";
export { ForwardRef as ReactComponent };